export default "__VITE_ASSET__254dcc95__"